export class GetTradeDataTransactionsError extends Error {}
